import React, { Component } from 'react';
import './PurchaseCompleted.css';
import "../../CommonStyles/CSS.css"
import dvas from '../../images/public/registeration/dvas.png';
import greenTick from '../../images/public/registeration/greenTick.png';
import redCross from '../../images/public/registeration/redCross.png';
import back from '../../images/public/registeration/back.png';
import help from '../../images/public/userarea/tab5u.png';
import pencil from '../../images/public/pencil.png';
import noImage from '../../images/public/noImage.png';
import crdscia from '../../images/public/userarea/crdscia.png';
import stck from '../../images/public/login/stck.png';
import logo from '../../images/public/login/logo.png';
import { element } from 'prop-types';
import classNames from 'classnames';
import { BrowserView, MobileView, isBrowser, isMobile, isFirefox, isTablet, isMobileOnly, isAndroid, isIOS, browserName } from 'react-device-detect';
import { Rectangle, Circle, Ellipse, Line, Polyline, CornerBox, Triangle } from 'react-shapes';
import { RadioGroup, Radio } from 'react-radio-group';
import { height } from 'window-size';
import WebFont from 'webfontloader';
import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
import Configminore from '../Configminore/Configminore';
import tr from '../../libs/tr'
import AlertPnl from "../../assets/components/panel/AlertPnl";
import RadioVerTwo from '../../assets/components/radiobtn/RadioVerTwo'
import { addToCart } from '../../libs/fetch'
import WaitLoad from "../../assets/components/loading/WaitLoad";
import Cookies from 'universal-cookie';
import { Button, Container, Row, Col, Modal } from 'react-bootstrap';
// import { getWorkFlow, modifyWorkflow, workflowState, updateWorkflow, workflowTransition, workflowHelp } from "../../libs/workflow";
import MPWorkFlow from "../../libs/workflow";
import { HtmlWrapper, fontStyles, getRouteName } from '../../Utils';
import InfoModal from "../../assets/components/Modal/Modal";
import FirebaseLogger from '../../libs/FirebaseLogger';
// const stageName = "Pay";
//import itabar4 from '../../images/public/registeration/nav4i.png';
//import engbar4 from '../../images/public/registeration/nav4e.png';
//import simplebar4 from '../../images/public/registeration/mobilenav4.png';
import TopBar from '../../assets/components/topbar/TopBar';
import miniArrow from '../../images/public/registeration/miniarrow.png';

const cookies = new Cookies();
class PurchaseCompleted extends Component {
  constructor(props) {
    super(props);

    let params = null;
    console.log('[PurchaseCompleted] props', this.props.location);

    this.state = {
      step: '4',
      isLoading: false,
      errmsg: null,
      errorFlg: false,
      workFlowInProgress: false, //used by workflow.js services to ensure data avaiability before next screen
      screenData: null,
      userOptions: [],
      canProceed: false,
      helpShow: false,
      helpMessage: "",
      googleUpdated: false,
      price_info_stored: false,
    };

  }

  componentDidMount() {
    console.log('initial this.state.screenData', this.state.screenData);
    // this.wf = new MPWorkFlow();
    // this.init();
    const workflow = localStorage.getItem('workflow');
    console.log('workflow set in update', workflow);
    this.setState({ screenData: JSON.stringify(workflow.data) }, async () => {
      this.refresh(() => {
            setTimeout(async () => {
            await this.update();
            }, 5000);
      });
    });
  }

  // async init() {
  //     // update screenData for current states
  //     await getWorkFlow(this, stageName);
  //     this.update();
  // }

  async update() {
    // updating server state...
    console.log('before workflowState update screenData', this.state.screenData);
    const nexiPaymentStatus = localStorage.getItem('nexiPaymentStatus');
    const isNexi = localStorage.getItem('isNexi');
    const nexiData = { ...this.state.screenData, success: nexiPaymentStatus == 'OK' ? 1 : 0 };
    const screenData = isNexi == 'true' ? nexiData : this.state.screenData;
    const payState = MPWorkFlow.getInstance().getStageName("Pay");
    const payWorkflow = MPWorkFlow.getInstance().getWorkFlow(this, payState);
    console.log('payWorkflow', payWorkflow);
    if (screenData) {
      this.setState({ screenData: { ...screenData, success: screenData.success } });
    }

    let resp = await MPWorkFlow.getInstance().workflowState(this, { state_data: screenData });

    if (!resp) return;
    if (resp.status === "success") {
      // Track payment completion
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      FirebaseLogger.getInstance().regEvent("PAYMENT_COMPLETED", {
        user_id: user.user_id,
        payment_success: screenData.success === 1,
        payment_method: isNexi == 'true' ? 'nexi' : 'other'
      }, screenData.success === 1 ? "SUCCESS" : "FAILED");

      // updating localStorage
      MPWorkFlow.getInstance().updateWorkflow(this, resp.data);
      // updating current screen
      this.setState({ googleUpdated: true }, () => {
        this.refresh();
      })
    }
  }

  async refresh() {
    // update screenData for current states
    const nexiPaymentStatus = localStorage.getItem('nexiPaymentStatus');
    console.log('before workflowState refresh screenData', this.state.screenData);
    const isNexi = localStorage.getItem('isNexi');
    const nexiData = { ...this.state.screenData, success: nexiPaymentStatus == 'OK' ? 1 : 0 };
    const screenData = isNexi == 'true' ? nexiData : this.state.screenData;
    const payState = MPWorkFlow.getInstance().getStageName("Pay");
    const resp = await MPWorkFlow.getInstance().getWorkFlow(this, payState);

    if (screenData) {
      this.setState({ screenData: { ...this.state.screenData, success: screenData.success } }, () => {

        if (this.state.screenData.success != 1) {
          this.checkForCreditCardInsertion();
        }
        // else {
        //   //get total amount
        //   let total_amount = this.state.screenData.total_amount;

        //   //get currency
        //   let currency = '';

        //   if (this.state.screenData.tracking.mypass_subscr) currency = this.state.screenData.tracking.mypass_subscr.currency;
        //   else if (this.state.screenData.tracking.paganella_subscr) currency = this.state.screenData.tracking.paganella_subscr.currency;

        //   window._fbq('track', 'Purchase', {
        //     currency: 'EUR',
        //     value: total_amount,
        //     status: !!this.state.screenData.success
        //   });

        //   FirebaseLogger.getInstance().regEvent("PAYMENT",
        //     {
        //       total_amount: total_amount,
        //       currency: currency,
        //     }, "NEW");

        //   window.gtag('event', 'conversion', { 'send_to': 'AW-323718630/ioe1CJ6Y8uQDEOabrpoB' });
        // }
      });
      console.log('canProceed', this.state.screenData);

      this.setState({ canProceed: this.state.screenData.link_next != "" });
      // if there's a successful purchase logging it only once
      if (!this.state.googleUpdated)
        this.checkForGoogleEventLogger();
    }
  }

  async transit(toWhere) {
    console.log('before workflowTransition 6');
    let resp = await MPWorkFlow.getInstance().workflowTransition(this, { to_state: toWhere });
    //console.log('[PurchaseCompleted] @transit #resp', resp);
    if (resp.status === "success") {
      // updating localStorage and navigating to the new screen
      MPWorkFlow.getInstance().updateWorkflow(this, resp.data);
      let nextScreen = MPWorkFlow.getInstance().getRouteName(toWhere);
      return this.props.history.push(nextScreen);
    } /*else if (resp.status === "fail") {
			this.setState({ errorFlg: true, errmsg: resp.message });
			}*/
  }

  alertResponse(info) {
    switch (info.type) {
      case "closeButton":
        this.setState({ errorFlg: false })
        break;
      case "actionButton":
        if (info.option1 == "attention") {
          this.setState({ errorFlg: false })
          break;
        }
    }
  }

  /* new functions for new flow */

  helpShowModal = (help_tag) => {
    MPWorkFlow.getInstance().workflowHelp(this, { tag: help_tag });
  }

  onEditAddress = () => {
    //return this.props.history.push('/');
    this.transit(this.state.screenData.link_update);
  }

  onBack = () => {
    //return this.props.history.push('/');
    this.transit(this.state.screenData.link_back);
  }

  gotoNextStage = (e) => {
    e.preventDefault();
    this.transit(this.state.screenData.link_next);
  }

  // in case of fail, checking for information to redirect to CC insert & pay screen
  checkForCreditCardInsertion = () => {
    const { screenData } = this.state;
    console.log('[PurchaseCompleted] @checkForCreditCardInsertion #screenDta', screenData);
    if (screenData.payment_status && screenData.payment_status == "fail_credit_card") {
      // let price_info = {
      //     info: screenData.totals,
      //     priceToPay: screenData.total_amount
      // }
      // localStorage.setItem("price_info", JSON.stringify(price_info));
      // window.gtag('event', 'conversion', { 'send_to': 'AW-323718630/fMYRCN7knoQYEOabrpoB' });
      this.props.history.push('/credit-card');
    }
  }

  checkForGoogleEventLogger() {
    try {
      const { tracking_valid, tracking } = this.state.screenData;
      if (tracking_valid == 1) {
        //console.log('[PurchaseCompleted] @checkForGoogleEventLogger #tracking', tracking);
        // get event name & price
        Object.keys(tracking).map((key, index) => {
          setTimeout(() => {
            const item = tracking[key];
            //console.log('[PurchaseCompleted] @checkForGoogleEventLogger #key', key);
            //console.log('[PurchaseCompleted] @checkForGoogleEventLogger #item', item);
            FirebaseLogger.getInstance().regEvent(key, item);
            // update the tracking_valid in workflow
          }, 100 * (index + 1));
        });
        this.state.screenData.tracking_valid = 0;
        this.update();
      }
      else {
        //console.warn('[PurchaseCompleted] @checkForGoogleEventLogger no more tracking is needed');
      }
    }
    catch (error) {
      //console.error('[PurchaseCompleted] @checkForGoogleEventLogger #error', error);
    }
  }

  render() {
    //console.log('[PurchaseCompleted]', this.state);
    return (
      <Router>
        <div>
          <div>
            <div className="sn_topbar"><TopBar step={this.state.step} /></div>
            <div className="sn_overlay d-lg-none"></div>
            <div className="sn_purchase">
              <div className="container">
                <div className="row">
                  <div className="col-12 col-lg-9 mx-auto">
                    <div className="sn_register__container p-3 p-md-4 p-lg-5">
                      <div className="row">
                        <div className="col-12 d-flex justify-content-between align-items-center">
                          <div className="sn_back">
                            {this.state.screenData && this.state.screenData.link_back && <a onClick={this.onBack}><img src={miniArrow} /></a>}
                          </div>
                          <div className="sn_quest">
                            {this.state.screenData && this.state.screenData.help_tag && <a onClick={() => this.helpShowModal(this.state.screenData.help_tag)}><img src={help} /></a>}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12 d-flex align-items-center flex-column">
                          <div className="sn_purchase__container__image mb-4">
                            {this.state.screenData && (this.state.screenData.success == 1) && <img src={greenTick} />}
                            {this.state.screenData && (this.state.screenData.success != 1) && <img src={redCross} />}
                          </div>
                          <h3 className="text-center">{this.state.screenData && HtmlWrapper(this.state.screenData.title)}</h3>
                          {
                            this.state.screenData && this.state.screenData.success == 0 && this.state.screenData.bank_message &&
                            <h5>{this.state.screenData && HtmlWrapper(this.state.screenData.bank_message)}</h5>
                          }
                          {
                            this.state.screenData && this.state.screenData.success == 1 &&
                            <h5 className="text-center">
                              {this.state.screenData && HtmlWrapper(this.state.screenData && this.state.screenData.note)}
                            </h5>
                          }
                          {
                            this.state.screenData && this.state.screenData.address && this.state.screenData.success == 1 &&
                            <div>
                              {this.state.screenData && HtmlWrapper(this.state.screenData && this.state.screenData.address)}
                              <div className="sn_pencil">
                                <a onClick={this.onEditAddress}>
                                  <img src={pencil} />
                                </a>
                              </div>
                            </div>
                          }
                          {
                            this.state.screenData && this.state.screenData.retry_button &&
                            <div className="row mt-3">
                              <div className="col-12 d-flex justify-content-center">
                                <div className="sn_container__button">
                                  <button className="sn_btn" onClick={this.onBack}>{this.state.screenData.retry_button}</button>
                                </div>
                              </div>
                            </div>
                          }
                          <div className="row mt-3">
                            <div className="col-12 d-flex justify-content-center">
                              <div className="sn_container__button">
                                <button className="sn_btn" onClick={this.gotoNextStage}>{this.state.screenData && this.state.screenData.next_button}</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {
              this.state.errorFlg ?
                <div className="containerModal">
                  {
                    this.state.errorFlg ?
                      <AlertPnl textbar1={tr.t("Attention")} secondbar={true} textbar2={this.state.errmsg} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"small"} option1={"attention"} callback={this.alertResponse.bind(this)} /> : null
                  }
                </div> : null
            }
          </div>
          <WaitLoad enable={this.state.workFlowInProgress} />
          {this.state.helpShow && <InfoModal info={this.state.helpMessage} show={true} onClose={() => this.setState({ helpShow: false })} />}
        </div>
      </Router>
    );
  }
}

export default PurchaseCompleted;



// WEBPACK FOOTER //
// ./src/screens/PurchaseCompleted/PurchaseCompleted.js